
import React from 'react';
import { portfolioData } from '../data/portfolioData';
import AiBackground from './AiBackground';

const Hero = () => {
    return (
        <div id="home" style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            paddingTop: '60px',
            position: 'relative',
            overflow: 'hidden'
        }}>
            <AiBackground />
            <div className="container fade-in" style={{ position: 'relative', zIndex: 1 }}>
                <style>
                    {`
                        .hero-title { font-size: 4rem; margin-bottom: 2rem; }
                        .hero-subtitle { font-size: 1.5rem; margin: 0 auto; max-width: 800px; color: var(--color-text-secondary); }
                        @media (max-width: 768px) {
                            .hero-title { font-size: 2.5rem; margin-bottom: 1.5rem; }
                            .hero-subtitle { font-size: 1.1rem; }
                        }
                    `}
                </style>
                <h1 className="hero-title">
                    {portfolioData.name}
                </h1>
                <p className="hero-subtitle">
                    {portfolioData.role}
                </p>
                <div style={{ marginTop: '3rem' }}>
                    <a href="#about" className="btn">About</a>
                </div>
            </div>
        </div>
    );
};

export default Hero;
